export default "__VITE_ASSET__bivLJ75N__"